/* AFIQ Volume 3 Teaser — vanilla JS
   - FAQ accordion (delegated)
   - Fallback signup form: Klaviyo _learnq.push(['identify', ...])
   - Sticky bar: hide while hero is in view, hide once #waitlist is in view
*/
(function () {
  'use strict';

  // -------- FAQ accordion --------
  function initFaq(root) {
    var toggles = root.querySelectorAll('[data-afiq-faq-toggle]');
    Array.prototype.forEach.call(toggles, function (btn) {
      if (btn.__afiqBound) return;
      btn.__afiqBound = true;
      btn.addEventListener('click', function () {
        var expanded = btn.getAttribute('aria-expanded') === 'true';
        var next = !expanded;
        btn.setAttribute('aria-expanded', String(next));
        var panelId = btn.getAttribute('aria-controls');
        var panel = panelId ? document.getElementById(panelId) : null;
        if (panel) {
          if (next) panel.removeAttribute('hidden');
          else panel.setAttribute('hidden', '');
        }
        var caret = btn.querySelector('.afiq-faq__caret');
        if (caret) caret.style.transform = next ? 'rotate(45deg)' : 'rotate(0deg)';
      });
    });
  }

  // -------- Fallback signup form --------
  function initFallbackForm(form) {
    if (form.__afiqBound) return;
    form.__afiqBound = true;

    form.addEventListener('submit', function (ev) {
      ev.preventDefault();

      var data = {
        email: (form.querySelector('[name="email"]') || {}).value || '',
        phone_number: (form.querySelector('[name="phone"]') || {}).value || '',
        player_level: (form.querySelector('[name="player_level"]') || {}).value || '',
        player_type: (form.querySelector('[name="player_type"]') || {}).value || ''
      };

      if (!data.email) {
        var emailInput = form.querySelector('[name="email"]');
        if (emailInput && emailInput.reportValidity) emailInput.reportValidity();
        return;
      }

      // Klaviyo identify — fires only if onsite JS has loaded.
      try {
        window._learnq = window._learnq || [];
        var payload = {
          $email: data.email,
          player_level: data.player_level,
          player_type: data.player_type
        };
        if (data.phone_number) payload.$phone_number = data.phone_number;
        window._learnq.push(['identify', payload]);
        window._learnq.push(['track', 'Joined Volume 3 VIP List', {
          player_level: data.player_level,
          player_type: data.player_type
        }]);
      } catch (e) {
        // Swallow — UI still confirms submission so the user isn't blocked.
      }

      // Hide form fields, show success state.
      var fields = form.querySelectorAll('.afiq-field, .afiq-field-row, .afiq-cta, .afiq-form__sub, .afiq-form__title, .afiq-form__legal, .afiq-form__badge');
      Array.prototype.forEach.call(fields, function (el) { el.style.display = 'none'; });
      var success = form.querySelector('.afiq-form__success');
      if (success) success.removeAttribute('hidden');
    });
  }

  // -------- Sticky bar visibility --------
  function initStickyBar(bar) {
    if (bar.__afiqBound) return;
    bar.__afiqBound = true;

    var hero = document.querySelector('.afiq-hero');
    var waitlist = document.getElementById('waitlist');
    if (!('IntersectionObserver' in window) || (!hero && !waitlist)) return;

    var heroVisible = false;
    var waitlistVisible = false;

    function update() {
      bar.style.display = (heroVisible || waitlistVisible) ? 'none' : 'flex';
    }

    if (hero) {
      new IntersectionObserver(function (entries) {
        heroVisible = entries[0].isIntersecting;
        update();
      }, { threshold: 0.25 }).observe(hero);
    }
    if (waitlist) {
      new IntersectionObserver(function (entries) {
        waitlistVisible = entries[0].isIntersecting;
        update();
      }, { threshold: 0.4 }).observe(waitlist);
    }
  }

  function init() {
    document.querySelectorAll('[data-afiq-faq]').forEach(initFaq);
    document.querySelectorAll('[data-afiq-fallback-form]').forEach(initFallbackForm);
    document.querySelectorAll('[data-afiq-sticky]').forEach(initStickyBar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-bind when the customizer reloads a section.
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:reorder', init);
})();
